//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import angular from 'angular';
import { INgRedux } from 'ng-redux';

import template from 'app/bulk-actions/bulk-selection-item-details/bulk-selection-item-details.html';
import 'app/bulk-actions/bulk-selection-item-details/bulk-selection-item-details.less';

import { DISTRIBUTION_ENDPOINTS } from '@apis/content-library/contentLibraryApiModel';
import { getGalleriesClientType } from '@galleries/selectors/getGalleriesClientType';
import { ICuralateStore } from '@models/AppState';
import { getDistributionEndpointLabel } from '@utils/distributionEndpointUtils';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface BulkSelectionItemDetails
  extends ReturnType<typeof BulkSelectionItemDetails['mapStateToProps']> {}

class BulkSelectionItemDetails {
  private static mapStateToProps(state: ICuralateStore) {
    return {
      galleriesClientType: getGalleriesClientType(state),
      isConnectClient: state.session.features.share_v2,
    };
  }

  public itemDetails?: {
    distributionEndpoints: DISTRIBUTION_ENDPOINTS[];
  };

  private readonly unsubscribe: () => void;

  constructor(private readonly $ngRedux: INgRedux) {
    this.unsubscribe = $ngRedux.connect(
      BulkSelectionItemDetails.mapStateToProps,
    )(this);
  }

  public $onDestroy() {
    this.unsubscribe();
  }

  public getDistributionEndpoints() {
    return (this.itemDetails?.distributionEndpoints ?? [])
      .map((endpoint) => {
        return getDistributionEndpointLabel(
          endpoint,
          this.galleriesClientType,
          this.isConnectClient,
        );
      })
      .filter((label) => label !== '');
  }
}
angular.module('curalate').component('bulkSelectionItemDetails', {
  bindings: {
    itemDetails: '<',
  },
  controller: ['$ngRedux', BulkSelectionItemDetails],
  template,
});
